var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopcorn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14.5l1.5-2.5h7l1.5 2.5H7z M4 19h16v-3H4v3z M7 4c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5S7.28 4 7 4zm10 0c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5S17.28 4 17 4zm-5 0c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5S12.28 4 12 4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopcorn);
export default __webpack_public_path__ + "static/media/popcorn.775deedbcea1f003c4bcf722161e2151.svg";
export { ForwardRef as ReactComponent };